import { repo } from 'index';
import { useQuery } from '@tanstack/react-query';

const DEFAULT_PER_PAGE = 10;

export const useEnterpriseDrivers = ({ perPage = DEFAULT_PER_PAGE, page = 1, mobileCont } = {}) => {
  const { data, status, isLoading, refetch } = useQuery({
    queryKey: ['enterprise-drivers', page, perPage, mobileCont],
    queryFn: () =>
      repo.fetchEnterpriseDrivers({
        page,
        perPage,
        mobileCont,
      }),
    refetchInterval: false,
  });

  const enterpriseDrivers = data?.data?.data ?? [];
  const enterpriseDriversPaging = data?.data?.paging ?? null;

  return {
    enterpriseDrivers,
    enterpriseDriversPaging,
    getEnterpriseDriversStatus: status,
    isGetEnterpriseDriversLoading: isLoading,
    refetchEnterpriseDrivers: refetch,
  };
};
